module.exports = __webpack_public_path__ + "img/pay.ffcf07c3.png";